import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/fin_entregas";

const getEntregas = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

// Filtros de la pantalla -> parámetros del backend (los vacíos no se envían).
const buildFiltros = (filters = {}) => ({
  search: filters.search || undefined,
  archivo: filters.archivo || undefined,
  oid_proyectos: filters.proyecto?.length ? filters.proyecto.join(",") : undefined,
  oid_depto: filters.departamento || undefined,
  oid_municipio: filters.municipio || undefined,
  oid_producto: filters.producto || undefined,
  tipo_entrega: filters.tipo_entrega || undefined
});

// Devuelve { data, total, page, limit }
const getEntregasPaginadas = async ({ page = 1, limit = 10, filters } = {}) => {
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params: { page, limit, ...buildFiltros(filters) }
  });
  return response.data;
};

const getEntregasStats = async (filters) => {
  const response = await axios.get(`${baseUrl}${endpoint}/stats`, {
    params: buildFiltros(filters)
  });
  return response.data;
};

// Todas las entregas que cumplen los filtros (para el Excel).
const getEntregasExport = async (filters) => {
  const response = await axios.get(`${baseUrl}${endpoint}/exportar`, {
    params: buildFiltros(filters)
  });
  return response.data;
};

// { proyectos: [oid], municipios: [oid] } con al menos una entrega.
const getEntregasFiltros = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}/filtros`);
  return response.data;
};

const createEntrega = async (data, usuario = "system") => {
  const response = await axios.post(`${baseUrl}${endpoint}`, data, {
    headers: { usuario }
  });
  return response.data;
};

const updateEntrega = async (id, data, usuario = "system") => {
  const response = await axios.put(`${baseUrl}${endpoint}/${id}`, data, {
    headers: { usuario }
  });
  return response.data;
};

const deleteEntrega = async (id, usuario = "system") => {
  const response = await axios.delete(`${baseUrl}${endpoint}/${id}`, {
    headers: { usuario }
  });
  return response.data;
};

const getStockProducto = async (id) => {
  const response = await axios.get(
    `${baseUrl}/api/financiero/fin_entregas/stock/${id}`
  );
  return response.data;
};

export {
  getEntregas,
  getEntregasPaginadas,
  getEntregasStats,
  getEntregasExport,
  getEntregasFiltros,
  createEntrega,
  updateEntrega,
  deleteEntrega,
  getStockProducto
};